module.exports = __webpack_public_path__ + "media/customizations/heritagelife/back-a43af931574088cba35d96acdc5eda5f.jpg";